export default __webpack_public_path__ + "static/media/ranking.3e71fbbf.png";